import React, { useEffect } from 'react';
import { Box, CustomModalLayout } from '@wix/design-system';
import { ProgressBarLoader } from '../ProgressBarLoader/ProgressBarLoader';
import { reportModalCtaClick, reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useInstallerContext } from '../../context/InstallerContext';
import { getIsBulkInstallTriggered } from '../../selectors/bulk-installer-triggered';
export const InstallingLoader = () => {
  const {
    onInstallationCompleted
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.installingLoader);
  }, []);
  const onCloseButtonClick = () => {
    reportModalCtaClick({
      ctaName: 'close',
      modalType: Modals.installingLoader
    });
    if (!getIsBulkInstallTriggered()) {
      onInstallationCompleted({
        status: 'CANCELED'
      });
    }
  };
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    dataHook: "installing-loader-custom-modal-layout",
    width: "600px",
    height: "700px",
    onCloseButtonClick: onCloseButtonClick
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    height: "100%",
    display: "flex",
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(ProgressBarLoader, null)));
};
//# sourceMappingURL=InstallingLoader.js.map